// extracted by mini-css-extract-plugin
export var askAiIcon = "_k3-9";
export var container = "_k3-0";
export var groupSeparator = "_k3-a";
export var highlight = "_k3-4";
export var resultIcon = "_k3-5";
export var resultItem = "_k3-7";
export var resultSubtitle = "_k3-3";
export var resultTitle = "_k3-2";
export var resultsList = "_k3-1";
export var searchGroup = "_k3-6";
export var selected = "_k3-8";